import axios, { AxiosError } from "axios";
import { notifyApiError } from "../errors";
import { getToken } from "../auth/session";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "http://localhost:3000",
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Attach the parent-issued bearer token (set via the postMessage handshake)
// to every request. Without it the backend responds 401.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    notifyApiError(error);
    return Promise.reject(error);
  },
);
